import axios from "axios";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useSearchParams } from "react-router-dom";
import UserTable from "../inputComponents/UserTable";

const VerifyStaffSheet = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [searchParams, setSearchParams] = useSearchParams();
  const [allRecords, setAllRecords] = useState([]);

  const [searchItems, setSearchItems] = useState({
    referenceNo: null,
    stamp: null,
  });

  // Encrypt Decrypt Data //
  const encrypt = (encrypDycrypData, type) => {
    let result;
    if (type === "Encrypt") {
      result = window.btoa(encrypDycrypData);
    } else if (type === "Decrypt") {
      result = window.atob(encrypDycrypData);
    }
    return result;
  };

  useEffect(() => {
    if (searchParams.has("payload")) {
      const realValue = searchParams.get("payload");
      let valuestring = encrypt(realValue, "Decrypt"); //Encrypt, Decrypt

      (async () => await tableLoad(valuestring))();
      
    } else {
    }
  }, [searchParams]);

  async function tableLoad(value) {
    if (value) {
      await axios
        .get(`${BASE_URL}verify/staffdataverify${value}`)
        .then((res) => {
          if (res.data.status === 200) {
            if (res.data.allData.length === 0) {
              swal(
                "Oops!",
                "Sorry! we did not find any information in the register",
                "warning"
              );
            } else {
              setAllRecords(res.data.allData);
              setSearchItems((prev) => ({
                ...prev,
                stamp: 1,
              }));
            }

            console.log(res.data.bend);
          } else {
            console.log(res.data.validation_error);
          }
        });
    }
  }

  return (
    <>
      <div className="container">
        <UserTable general={searchItems} itemId={allRecords} />
      </div>
    </>
  );
};

export default VerifyStaffSheet;
